import { useQuery } from "@apollo/client";
import { type ProviderData } from "components/Auth";
import { type Address, type InvoiceDetails } from 'components/Invoicing/interfaces';
import { CONTRACTED_SERVICES_QUERY } from "components/ProviderProfile/components/Tabs/PracticeInfo/queries";
import { COUNTRY_CODE, OFFICE_TYPE } from 'utils/regionUtils';


export const isStaffProvider = (employmentTypeId?: number) => employmentTypeId === 1 || employmentTypeId === 2 

export const checkIfStaffProvider = (providerData?: ProviderData) => isStaffProvider(providerData?.provider?.employmentTypeId)

export const isContractorProvider = (employmentTypeId?: number) => !isStaffProvider(employmentTypeId)

export const checkIfContractorProvider = (providerData?: ProviderData) => isContractorProvider(providerData?.provider?.employmentTypeId)

export const isNewZealandProvider = (invoice: InvoiceDetails): boolean => {
    const vendorCountry = invoice?.provider?.vendor?.address?.countryCode?.toLowerCase();
    const mailingAddresses = invoice?.provider?.contactInfo?.addresses;
    
    const hasNZVendorAddress = vendorCountry === COUNTRY_CODE.NZ;
    const hasNZMailingAddress = mailingAddresses?.some(
        address => address.officeType === OFFICE_TYPE.MAILING_ADDRESS && 
                  address?.countryCode?.toLowerCase() === COUNTRY_CODE.NZ
    );

    return hasNZVendorAddress || hasNZMailingAddress || false;
};

export const getProviderContactAddress = (invoice: InvoiceDetails) : Address =>
    invoice.provider.vendor?.address
    || invoice.provider.contactInfo?.addresses?.find(addr => addr.officeType === OFFICE_TYPE.MAILING_ADDRESS)
    || invoice.provider.contactInfo?.addresses?.[0];

export function useProviderContractedServices(providerId: number) {
    const { data, loading, error } = useQuery(CONTRACTED_SERVICES_QUERY, {
        fetchPolicy: 'cache-first',
        variables: { providerId },
        errorPolicy: 'all',
        skip: !providerId,
    });

    return { contractedServices: data?.providerContracts, loading, error };
}